import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { ResponseTypeEnum } from '../models/enums';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
var UserProfileService = /** @class */ (function () {
    function UserProfileService(http) {
        var _this = this;
        this.http = http;
        this.getUserProfile = function () {
            return _this.http.Get(URLS.getUserProfile);
        };
        this.saveUserProfile = function (user) {
            return _this.http.Post(URLS.saveUserProfile, user, ResponseTypeEnum.Success);
        };
    }
    UserProfileService.ngInjectableDef = i0.defineInjectable({ factory: function UserProfileService_Factory() { return new UserProfileService(i0.inject(i1.BaseHttpService)); }, token: UserProfileService, providedIn: "root" });
    return UserProfileService;
}());
export { UserProfileService };
